import { css, cx } from "@linaria/core";
import { DetailedHTMLProps, HTMLAttributes } from "react";

const headerStyles = css`
  position: relative;
  height: 24px;
  padding-bottom: 14px;
  margin-bottom: 20px;
  border-bottom: 2px solid rgba(67, 67, 67, 0.1);

  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const Header = (
  props: DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement>,
) => {
  return <header {...props} className={cx(props.className, headerStyles)} />;
};

const headingStyles = css`
  margin: 0;

  color: #262626;
  font-family: var(--font-family);
  font-size: calc(30 * var(--font-px));
  font-weight: 800;
  line-height: 1;

  /** In case we're in mobile mode, ensure heading is still rendered properly */
  & > button {
    -webkit-appearance: none;
    background: transparent;
    margin: 0;
    padding: 0;
    outline: none;
    border: none;

    font-size: inherit;
    font-family: inherit;
    font-weight: inherit;
    line-height: inherit;
    text-transform: inherit;
    color: inherit;

    display: flex;
    align-items: center;

    cursor: pointer;

    transition: color 0.1s linear;

    /** Create spacing between chevron and title */
    & > i {
      margin-right: 20px;
    }

    &:hover,
    &:focus {
      color: var(--color-primary);
    }
  }
`;

export const Heading = (
  props: DetailedHTMLProps<
    HTMLAttributes<HTMLHeadingElement>,
    HTMLHeadingElement
  >,
) => {
  return <h1 {...props} className={cx(props.className, headingStyles)} />;
};
